import React from 'react';
import { Icon, Box, Button, Popover, PopoverTrigger, PopoverContent, PopoverArrow, } from '@spothero/ui';
import IconInfo from '@spothero/icons/info-circle-filled';
/**
 * ReviewTooltip - A reusable popover component that displays informational content
 * when clicking an info icon. Used across review sections for contextual help.
 *
 * Features:
 * - Click-to-open popover with dark variant styling
 * - Lazy loading for performance (only renders when opened)
 * - Custom z-index handling to appear above HR/Divider elements
 *
 * Z-Index Solution:
 * We use a custom Popper.js modifier to set z-index on the popper wrapper element.
 * This is necessary because:
 * 1. Setting zIndex on PopoverContent only affects the content, not the wrapper
 * 2. The .chakra-popover__popper wrapper needs the z-index to appear above Dividers
 * 3. The modifier runs in the 'write' phase to apply styles directly to the popper element
 */
export const ReviewTooltip = ({ children, ariaLabel }) => {
    const handleClick = (e) => {
        // only allow genuine user interactions
        if (!e.isTrusted) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    return (<Popover placement="bottom" variant="dark" isLazy 
    // Custom Popper.js modifier to set z-index on the popper wrapper
    // This ensures the popover appears above HR/Divider elements
    modifiers={[
            {
                name: 'zIndex',
                enabled: true,
                phase: 'write',
                fn({ state }) {
                    // Apply z-index directly to the popper wrapper element
                    // This is the .chakra-popover__popper element in the DOM
                    state.styles.popper.zIndex = 10000;
                    return state;
                },
            },
        ]}>
            <PopoverTrigger>
                <Button variant="tertiary" aria-label={ariaLabel} data-testid="ReviewTooltip" onClick={handleClick} cursor="pointer" display="inline-flex" alignItems="center" padding={0} minWidth="auto" height="auto">
                    <Icon as={IconInfo} boxSize={4} color="gray.500"/>
                </Button>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow />
                <Box fontWeight="normal">{children}</Box>
            </PopoverContent>
        </Popover>);
};
